<div>
    <mat-toolbar color="primary" class="custom-content-justify footer-container">
        <div class="verison-container">
            <p class="version">2.1.5014</p>
            <a class="info-btn-box" *ngIf="showUpdateChecker">
            <mat-icon>info_outline</mat-icon>
            </a>
        </div>
        <div *ngIf="enableIntegrationServer">Diese Anwendung ist für den Integrationsserver aktiviert.</div>
        <a target="_new" href="https://www.nexus-schauf.de/"><span class="desktop-footer-text-bar" [innerHTML]="get_right_footer_text()"></span></a>
    </mat-toolbar>
</div>
